import { BaseButton, Divider, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C2Text, C4Text } from "../../../common/components/text/CustomText";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import { useEffect, useState } from "react";
import { InfoTable } from "../../../common/components/table/InfoTable";
import CustomModal from "../../../common/components/modal/CustomDetailModal";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import ParseUtil from "../../../common/utils/ParseUtil";
import { Theme } from "../../../common/Theme";
import RevenueService from "../../../service/RevenueService";

const InfoTableTitles = {
    name: "Name",
    type: "Type",
    id: "ID",
    modelId: "Model ID",
    activatedDate: "Activated Date",
};

export function RevenueDetailModal({ isOpen, onClose, dto, title }) {
    const service = new RevenueService();
    const [transactionId] = useState(dto?.transactionId || "");
    const [shopName, setShopName] = useState(dto?.shopName || "");
    const [shopCode, setShopCode] = useState(dto?.shopCode || "");
    const [deviceName, setDeviceName] = useState(dto?.deviceName || "");
    const [payment, setPayment] = useState(dto?.payment || "");
    const [amount, setAmount] = useState(dto?.amount || "");
    const [result, setResult] = useState(dto?.result || "");
    const [registredDate, setRegistredDate] = useState(dto?.registerdDate || "");
    const [device, setDevice] = useState(
        dto?.device || { name: "-", type: "-", id: "-", modelId: "-", activatedDate: "--" }
    );
    const infoArray = ParseUtil.parseObjectToInfoTableArray(device, InfoTableTitles);

    useEffect(() => {
        // 디바이스 정보 불러오기
        if (deviceName !== "") {
            setDevice({
                name: "W001",
                type: "Washer",
                id: "FH069FD_T",
                modelId: "FH069FD_T",
                activatedDate: "2025-08-09 13:20:48",
            });
        }
    }, [deviceName]);

    // Void 상태는 API 개별 조회가 없음 (spec 04.01.05.06은 기간 합계만 제공)
    const [voidData, setVoidData] = useState(null);

    // Void Modal
    const [isVoidPopupOpen, setIsVoidPopupOpen] = useState(false);
    const [isVoidProcessing, setIsVoidProcessing] = useState(false);

    const handleVoidClose = () => {
        setIsVoidPopupOpen(false);
    };

    const handleVoidOk = () => {
        setIsVoidProcessing(true);
        service
            .saveRevenueVoid({ request: { orderId: transactionId } })
            .then((result) => {
                setVoidData(result);
                setIsVoidPopupOpen(false);
                setResult("Voided");
            })
            .catch((error) => {
                console.error("Error saving void:", error);
                setIsVoidPopupOpen(false);
            })
            .finally(() => {
                setIsVoidProcessing(false);
            });
    };

    return (
        <CustomModal title={title} isOpen={isOpen} onClose={onClose} side={"right"} width={"552px"}>
            <SizedBox
                width={"100%"}
                height={"100%"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"22px 0 0 0"}
            >
                <Row alignItem={"flex-start"} justifyContent={"space-between"} width={"100%"} padding={"0 20px"}>
                    <C2Text fontWeight={"600"}>Transaction ID</C2Text>
                    <C1Text fontWeight={"600"}>{transactionId}</C1Text>
                </Row>
                <SizedBox height={"20px"} />
                <Divider />
                <Padding padding={"20px 20px 11px 20px"} style={{ width: "100%" }}>
                    <C2Text fontWeight={"500"}>Shop</C2Text>
                    <SizedBox height={"5px"} width={"100%"} />
                    <TitleAndInput
                        title={"Name"}
                        type={"normal"}
                        inputValue={shopName}
                        setInputValue={setShopName}
                        disabled={true}
                        hasDot
                    />
                    <Divider marginTop={"11px"} thickness={"0px"} />
                    <TitleAndInput
                        title={"Code"}
                        type={"normal"}
                        inputValue={shopCode}
                        setInputValue={setShopCode}
                        disabled={true}
                        hasDot
                    />
                    <Divider marginTop={"11px"} marginBottom={"16px"} />
                    <TitleAndInput
                        title={"Device Name"}
                        type={"normal"}
                        inputValue={deviceName}
                        setInputValue={setDeviceName}
                        disabled={true}
                    />
                    <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={"Payment"}
                        type={"normal"}
                        inputValue={payment}
                        setInputValue={setPayment}
                        disabled={true}
                    />
                    <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={"Amount"}
                        type={"normal"}
                        inputValue={amount}
                        setInputValue={setAmount}
                        disabled={true}
                    />
                    <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={"Result"}
                        type={"normal"}
                        inputValue={result}
                        setInputValue={setResult}
                        disabled={true}
                    />
                    <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                    <TitleAndInput
                        title={"Registerd Date"}
                        type={"normal"}
                        inputValue={registredDate}
                        setInputValue={setRegistredDate}
                        disabled={true}
                    />
                </Padding>
            </SizedBox>
            <SizedBox height={"16px"} />
            <SizedBox
                width={"100%"}
                height={"100%"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"20px 21px"}
            >
                <C2Text fontWeight={"600"}>Device Info</C2Text>
                <SizedBox height={"12px"} width={"100%"} />
                <InfoTable data={infoArray} />
            </SizedBox>
            <SizedBox height={"51px"} />
            <Row justifyContent={"flex-end"} width={"100%"}>
                <BaseButton
                    padding={"8px 14.5px"}
                    backgroundColor={Theme.color.indigo500}
                    border={"none"}
                    fontColor={Theme.color.neutral100}
                    onClick={() => {
                        setIsVoidPopupOpen(true);
                    }}
                >
                    <C4Text cursor={"pointer"} fontWeight={"400"} fontColor={Theme.color.neutral100}>
                        {"Void"}
                    </C4Text>
                </BaseButton>
            </Row>
            <CustomPopup
                isOpen={isVoidPopupOpen}
                onClose={handleVoidClose}
                onConfirm={handleVoidOk}
                message={"Would you like to void this transaciton?"}
            />
        </CustomModal>
    );
}
